<template>
  <div id="journey" class="video-module">
    <section class="page-section">
      <div class="video-container container" id="video">
        <div class="video">
          <div class="overlay">
            <video controls>
              <source
                src="https://static.porscheautoinsurance.com/video/PorscheAutoInsurance.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'VideoSection'
};
</script>

<style scoped lang="scss">
.video-module {
  background-color: #eff0f1;
}

div.video {
  display: flex;
  position: relative;
  justify-content: center;

  div.overlay {
    width: 100%;

    video {
      border-radius: 12px;

      @media (min-width: 760px) {
        box-shadow: 0 4px 16px $grey;
      }
    }
    p {
      position: absolute;
      top: 50%;
      left: 45%;
      font-size: larger;
      color: $white;
    }
  }
}

.secondary-title {
  font-size: 1rem;
  line-height: 1.5rem;
}
</style>
